import React from 'react';
import { connect } from 'react-redux';
import FileInput from '../containers/FileInput';
import MassHead from '../components/MassHead';

import {
	getXMLfromString,
	cleanXMLString,
	insertXMLNodes
} from '../utilities';

const mapStateToProps = (state) => ({
	exportFileContent: state.parseExportFile.exportFileContent,
	menuNodes: state.parseExportFile.menuNodes,
	menuTermNodes: state.parseExportFile.menuTermNodes,
	authorNodes: state.parseExportFile.authorNodes,
	hasBeenRead: state.parseExportFile.hasBeenRead
})

const mapDispatchToProps = (dispatch) => ({})

class Menu extends React.Component {

	prepareXML() {

		const { exportFileContent, menuNodes, authorNodes, menuTermNodes } = this.props;

		let newXmlDoc = getXMLfromString(cleanXMLString(exportFileContent));
		newXmlDoc = insertXMLNodes(newXmlDoc, 'channel', authorNodes);
		newXmlDoc = insertXMLNodes(newXmlDoc, 'channel', menuTermNodes);

		// INSERT MENU ITEM FILTERED NODES
		for (let navItem in menuNodes) {

			let hasLink = true;
			var metas = menuNodes[navItem].querySelectorAll('meta_key');

			for(const meta in metas) {

				/**
				Change the type of Menu Items linked to an existing page to 'custom'
				We are not importing pages so menu items with reference to pages will fail.
				*/
				if ( metas[meta].textContent === "_menu_item_object" || metas[meta].textContent === "_menu_item_type" ) {

					const type = metas[meta].nextElementSibling.textContent;
					if (type === 'page' || type === 'post_type') {

					  metas[meta].nextElementSibling.innerHTML = '<![CDATA[custom]]>';
					}
				}

				if ( metas[meta].textContent === "_menu_item_url" ) {

					hasLink = metas[meta].nextElementSibling.textContent.length > 0;
				}        
			}

			// Mark incomplete Menu Items with labels
			let title = menuNodes[navItem].getElementsByTagName('title')[0];
			title.textContent = title.textContent.length <= 0 ? '** SET LABEL' : title.textContent;
			title.textContent = !hasLink ? title.textContent + ' ( NO URL )' : title.textContent;

			newXmlDoc.getElementsByTagName('channel')[0].appendChild(menuNodes[navItem]);
		}

		return new XMLSerializer().serializeToString(newXmlDoc);
	}

	render() {

		const { hasBeenRead } = this.props;
		const file = new Blob([this.prepareXML()], {type: 'text/plain'});
		const link = URL.createObjectURL(file);

		return (
			<div className="Menu">
				<MassHead hasBeenRead={hasBeenRead} />
				<FileInput />
				{
					hasBeenRead ?
					<div className='tc mt4'>
						<a
				    		href={link}
				    		download={'wp_menu_import_' + new Date().toLocaleString() + '.xml'}
				    		className='bg-brand-magenta white hover-white dib pv3 ph4 no-underline f4 pointer grow'>
				    		Download Menu Export File
						</a>
					</div>
					: ''
				}
	        <div className='flex justify-start'>
	          <div className='w-75-ns f6 pa2 mt4'>
	            <strong>Notes:</strong>
	            <ul className='lh-copy'>
	              <li>Menu items which are linked to pages and not through URLs will be marked with (No Label) and/or (No URL).</li>
	              <li>After importing the Menu, don't forget to set it as Main. You can do this on Admin > Appearance > Menus > Manage Locations tab.</li>
	            </ul>
	          </div>
	        </div>				
			</div>
			)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Menu);